export const PDS_LABEL = 'Receive a Product Disclosure Statement and Fact Sheet';
export const REPORTS_LABEL = 'Receive recent fund performance reports';
export const OTHER_LABEL = 'Make another enquiry';
export const FOOTER_PARAGRAPH_1 = 'Only to be used for sending genuine email enquiries to the '
  + 'Contributor. Livewire Markets Pty Ltd reserves its right to take any legal or other '
  + 'appropriate action in relation to misuse of this service.';
export const FOOTER_PRE_POLICY = 'Your personal information will be passed to the Contributor '
  + 'and/or its authorised service provider to assist the Contributor to contact you about your '
  + 'investment enquiry. They are required not to use your information for any other purpose. Our ';
export const FOOTER_POST_POLICY = ' explains how we store personal information and how you may '
  + 'access, correct or complain about the handling of personal information.';
